// extracted by mini-css-extract-plugin
module.exports = {"root":"_3bM8k","feature":"Ck5w-"};